<template>
    <div class="top-menu-row">
        <span class="row-name" v-if="name">{{ name }}</span>
        <div class="items">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: ["name", "icon"],
    components: {
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<i18n>
{
    en: {
    },
    ru: {
    }
}
</i18n>

<style lang="scss" scoped>
.top-menu-row {
    padding: 24px;
    .row-name {
        font-weight: 600;
        font-size: 1.1em;
    }
    .items {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 16px;
    }
}
</style>